import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
import { useMutation } from "@apollo/client";

import { GlobalState } from "contexts/GlobalState";
import { UPDATE_USER } from "schemas/profile";
import { ReactRegisterModal } from "widgets/RegisterForm/components/ReactRegisterModal/index";
import "./style.scss";

const ProfileSaveChoices = forwardRef((props, ref) => {
  const [showRegister, setShowRegister] = useState(false);
  const [modalOpen, setmodalOpen] = useState(false);
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [updateUser, { data: data, error: error }] = useMutation(UPDATE_USER);

  const handleClose = () => setmodalOpen(false);

  useEffect(() => {
    if (data) {
      setGlobalUser({
        user: { ...data.updateUser },
      });
      setmodalOpen(false);
    }
    if (error) {
      console.log(error);
    }
  }, [data, error]);
  const updateUserChoices = () => {
    if (props.registrationFormChoices && globalUser.user) {
      updateUser({
        variables: {
          psychometric: globalUser.user.psychometric ?? "",
          maturity: globalUser.user.maturity ?? "",
          adapter: globalUser.user.adapter ?? "",
          filters: globalUser.user.filters ?? {},
          registrationFormChoices: props.registrationFormChoices ?? {},
        },
      });
      window.location.href = props.labels.FavoriteButtonsWrapper.labels.profile_url;
    }
    if (!globalUser.user) {
      setShowRegister(true);
    }
  };
  useImperativeHandle(ref, () => ({
    setShow(flag) {
      setmodalOpen(flag);
    },
  }));

  return (
    <div>
      {!props.isDetailsForm &&
        < Modal show={modalOpen} onHide={handleClose} dialogClassName="modal-save-choices">
          <Modal.Header className="custom-modal-head">
            <Button aria-label={props.labels.closePopup} className="close" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <Row className="main-content-row">
              <Col sm="auto" className="circle-wrapper">
                <div className="circle" />
              </Col>
              <Col className="body-content">
                <Modal.Title tabIndex="0">{props.labels.popupTitle}</Modal.Title>
                <p>{props.labels.poupDescription}</p>
                <Row className="btns-row">
                  <Col xs={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }}>
                    <Button aria-label={props.labels.popupNotSave} variant="secondary" onClick={handleClose}>
                      {props.labels.popupNotSave}
                    </Button>
                  </Col>
                  <Col xs={{ span: 12, order: 1 }} md={{ order: 2 }}>
                    <Button aria-label={props.labels.popupSave} variant="primary" onClick={updateUserChoices}>
                      {props.labels.popupSave}{" "}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      }
      <ReactRegisterModal
        show={showRegister}
        setShow={setShowRegister}
        labels={props.labels.RegisterForm.labels}
        lastAction={{
          action: updateUserChoices
        }}
      />
    </div >
  );
});
export default ProfileSaveChoices;
